import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field } from 'redux-form'
import Media from 'components/common/Media'
import Button from 'components/common/Button/Button'
import Text from 'components/common/Text/Text'
import { preventDefault } from 'helpers/utils'
import { Buttons, Col } from '../Shared.styles'
import CheckboxListField from './components/CheckboxListField'
import ResetControl from './components/ResetControl'
import model from './viewModel'

const CommunicationPreferencesForm = ({
  accountContactDetails,
  onCancel,
  setFocusScopeRef,
  handleSubmit,
  submitting
}) =>
  <form noValidate data-at-communication-preferences-form onSubmit={ handleSubmit }>
    <CustomCol ref={ setFocusScopeRef }>
      <CustomText block bold data-at-reminders>Reminders</CustomText>
      <Field
        { ...model.reminders }
        accountContactDetails={ accountContactDetails }
        ResetControl={ ResetControl }
        component={ CheckboxListField } />
    </CustomCol>
    <CustomCol>
      <CustomText block bold data-at-promotions>Promotions</CustomText>
      <Field
        { ...model.promotions }
        accountContactDetails={ accountContactDetails }
        ResetControl={ ResetControl }
        component={ CheckboxListField } />
    </CustomCol>
    <Buttons>
      <Button data-at-communication-save-button disabled={ submitting }>Save</Button>
      <Button data-at-communication-cancel-button link onClick={ preventDefault(onCancel) }>Cancel</Button>
    </Buttons>
  </form>

CommunicationPreferencesForm.propTypes = {
  accountContactDetails: PropTypes.shape(),
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  setFocusScopeRef: PropTypes.func,
  submitting: PropTypes.bool
}

export default CommunicationPreferencesForm


const CustomText = styled(Text.withComponent('legend'))`
  margin-bottom: 18px;
`

const CustomCol = styled(Col.withComponent('fieldset'))`
  ${Media.desktop`
    padding-bottom: 0;
  `}
`
